import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { ButtonComponentStyles } from '../../../utils/utils';
import Button from '../../Button/button';
import './becomeAPartnerForm.scss';
import FormField from '../../Form/FormField/formField';
import FormContainer from '../../Form/formContainer';
import { becomeAPartnerService } from '../../../services/becomeApartner.service';

const BecomeAPartnerForm = () => {
  return (
    <div className="become-a-partner-form-container">
      <Formik
        initialValues={{
          name: '',
          company: '',
          email: '',
        }}
        validationSchema={Yup.object({
          name: Yup.string().max(15, 'Must be 15 characters or less').required('Required'),
          company: Yup.string().max(20, 'Must be 20 characters or less').required('Required'),
          email: Yup.string().email('Invalid email address').required('Required'),
        })}
        onSubmit={async (values, formikBag) => {
          becomeAPartnerService({ email: values.email, firstName: values.name, lastName: values.name });
          formikBag.resetForm();
        }}
      >
        <FormContainer>
          <FormField className="form-control" id="name" name="name" placeholder="Name" />
          <FormField className="form-control" id="company" name="company" placeholder="Company" />
          <FormField className="form-control" id="email" name="email" placeholder="jane@acme.com" type="email" />
          <Button buttonStyle={ButtonComponentStyles.PRIMARY} title="Submit" />
        </FormContainer>
      </Formik>
    </div>
  );
};

export default BecomeAPartnerForm;
